import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import "./App-Responsive.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import "./i18n/i18n.js";
import { PersistGate } from "redux-persist/lib/integration/react.js";
import { SocketProvider } from "./Modules/Components/SocketContext.js";
import { CustomToastContainer } from './Modules/Components/Toster.js'


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={""}>
      <SocketProvider>
        <Provider store={store}>
          <CustomToastContainer />
          <PersistGate persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </SocketProvider>
    </Suspense>
  </React.StrictMode>
);
reportWebVitals();
